import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 获取未绑定的官方样衣
    wbdget: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/promotion/getUnbindProductList`, params),
    //获取已绑定的官方样衣
    ybdget: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/promotion/getBindProductList`, params),
    //查询面料供应
    mlget: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/promotion/getFabricBindList`, params),
    //查询辅料供应
    flget: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/promotion/getAccessoryBindList`, params),
    //绑定面料供应
    mlbd: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/promotion/bindFabric`, params),
    //绑定辅料供应
    flbd: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/promotion/bindAccessory`, params),
}